import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storeList: [],
};

const storelistSlice = createSlice({
  name: "storeList",
  initialState,
  reducers: {
    setStorelist: (state, action) => {
      state.storeList = action.payload;
    },
    clearStorelist: (state) => {
      state.storeList = [];
    },
  },
});


export const { setStorelist, clearStorelist } = storelistSlice.actions;


export default storelistSlice.reducer;
